module.exports = __webpack_public_path__ + "img/solutions_3.9723b39e.png";